import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ct-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
